import { Text } from "@chakra-ui/react";

export function NoPatientData({ message = "No Data Available" }: { message?: string }) {
  return <Text>{message}</Text>;
}
